import { useState, useCallback } from "react";
import { db } from "../services/firebase";
import { ref, push, set } from "firebase/database";

/**
 * ✅ Custom hook for creating an interview under a specific pack
 */
export default function useCreateInterview() {

    const [creatingInterview, setCreatingInterview] = useState(false);
    const [error, setError] = useState(null);

    const createInterview = useCallback(async (domainId, packId, data) => {

        if (!domainId || !packId) {
            setError("Missing domain or pack ID");
            return false;
        }
        if (!data.name?.trim()) {
            setError("Please enter a valid interview name");
            return false;
        }

        try {
            setCreatingInterview(true);
            setError(null);

            const interviewRef = push(ref(db, `Interviews/${domainId}/${packId}`));

            const interviewData = {
                id: interviewRef.key,
                name: data.name.trim(),
                isFree: data.isFree,
                requirements: data.requirements?.trim() || "",
                orderId: data.orderId ? parseInt(data.orderId, 10) : Date.now(),
                createdAt: Date.now(),
            };

            await set(interviewRef, interviewData);
            return true;
            
        } catch (err) {
            console.error("❌ Error creating interview:", err);
            setError("Failed to create interview");
            return false;
        } finally {
            setCreatingInterview(false);
        }
    }, []);

    return { createInterview, creatingInterview, error };
}
